import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import { PROMO_SLOT } from 'Pods/SearchPage/Shared/Tracking/constants'
import usePromoTracking from 'Pods/SearchPage/Shared/Tracking/usePromoTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

const NEW_PROJECT_PATH = '/3d-modeling-jobs/new'
const PROMOTION_ID = 'custom_project'
const META_SOURCE_BY_SLOT = {
  [PROMO_SLOT.EMPTY_STATE]: 'search_empty_state',
  [PROMO_SLOT.RESULTS_BOTTOM]: 'search_results_bottom',
}

function FreelancerCard({ slot, index }) {
  const translate = useTranslate()
  const { ref, handleSelect } = usePromoTracking({ id: PROMOTION_ID, slot, index })
  // ProjectsForm reads meta_source with a plain string replace, so it must stay the only param.
  const href = `${NEW_PROJECT_PATH}?meta_source=${META_SOURCE_BY_SLOT[slot]}`

  return (
    <div ref={ref} className="promo-card">
      <div className="promo-card__text">
        <h3 className="promo-card__title cgt-heading-400">
          {translate('search_page.promo_cards.freelancer.title')}
        </h3>
        <p className="promo-card__description cgt-body-lg">
          {translate('search_page.promo_cards.freelancer.description')}
        </p>
      </div>
      <div className="promo-card__actions">
        <Button
          href={href}
          type="primary"
          size="medium"
          customClass="promo-card__button"
          onClick={handleSelect}
        >
          {translate('search_page.promo_cards.freelancer.cta')}
        </Button>
      </div>
    </div>
  )
}

FreelancerCard.propTypes = {
  slot: string.isRequired,
  index: number.isRequired,
}

export default FreelancerCard
